import m, {MithrilComponent} from '@bitstillery/mithril'

import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const placeholderCardMeta = {
    tier: 'content',
    summary: 'Dashed-outline placeholder tile for an empty/CTA slot in a Grid (e.g. a “join the team” call-to-action).',
    when_to_use:
        'Drop into a `Grid` alongside content cards as an empty-state or call-to-action slot — e.g. after the ' +
        '`ProfileCard`s on a team page. Fill it with a `Heading`, `Paragraph` and a `Button` (link to a target such ' +
        'as `/vacancies`). Content-driven; it matches the surrounding cards’ footprint.',
    props: 'No props — children only.',
    example: `
    <PlaceholderCard>
        <Heading level={3}>Want to join the team?</Heading>
        <Paragraph>We are always looking for traders.</Paragraph>
        <Button link="/vacancies" text="See vacancies" type="info" />
    </PlaceholderCard>
    `,
} satisfies CmsComponentMeta

/**
 * Dashed-outline tile that centres its children within a `Grid` cell — an empty-state or
 * call-to-action slot (e.g. “want to join the team?”). Compose it with a `Heading`, `Paragraph`
 * and a `Button`; the look follows its content, so there is no variant to pick.
 */
export class PlaceholderCard extends MithrilComponent {
    view(vnode: m.Vnode) {
        return (
            <article className='view-placeholder-card'>
                <div className='view-placeholder-card-inner'>{vnode.children}</div>
            </article>
        )
    }
}
